<template>
  <div class="column is-4-tablet is-6-mobile">
    <div
      class="card-grid"
      :class="{ offline: bookmark.offline }"
    >
      <div class="columns mb-0 is-mobile">
        <div class="column py-0">
          <!-- <header class="columns is-mobile">
            <div class="column pb-0">
              <a
                :href="bookmark.url"
                target="_blank"
                class="card-header-title"
              >
                {{bookmark.title}}
              </a>
            </div>
            <div class="column pb-0 is-2 has-text-right">
              <time datetime="2016-1-1">01/01/2016</time>
            </div>
          </header> -->
          <div class="pt-1">
            <a
              :href="bookmark.url"
              target="_blank"
              @click.exact.prevent="bookmarkClick(bookmark)"
            >
              <b-image
                :src="imageUrl"
                :alt="bookmark.title"
                ratio="5by4"
                class="bookmark-image"
              />
            </a>
          </div>
        </div>
      </div>

      <footer class="card-footer">
        <b-button
          v-if="!tagsVisible"
          type="is-small is-light is-stealth is-fullwidth"
          @click="showTags"
        >
          {{ tagsLeft.length }}
          <span v-if="selectedTags.length > 0">more</span>
          tags
        </b-button>
        <div
          v-else
          @dblclick="openViaExtension(bookmark)"
        >
          <TagList
            :tags="tagsNames(bookmark.tags)"
            :selected-tags="selectedTags"
            class="card-footer-item"
            @tagClicked="addTag"
          />

          <BookmarkActionsMenu
            :bookmark="bookmark"
            :show-open="true"
            @openViaExtension="openViaExtension"
            @editRecord="editRecord"
            @confirmDeleted="confirmDelete"
            @deletedSelected="deleteSelected"
            @reparse="reparse"
            @wayback="wayback"
          />
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import TagList from '@/qlipmark-shared/components/tags/TagList.vue'
  import BookmarkActionsMenu from '@/components/bookmarks/BookmarkActionsMenu.vue'

  export default {
    name: 'BookmarkCardGrid',
    components: {
      TagList,
      BookmarkActionsMenu
    },
    props: ['bookmark', 'index', 'selectedTags', 'tagsNames'],
    data: function() {
      return {
        tagsVisible: false,
      }
    },
    computed: {
      imageUrl() {
        return this.bookmark.imageUrl ? this.bookmark.imageUrl : '/images/defaults/bookmark-missing.png'
      },
      tagsLeft() {
        return this.tagsNames(this.bookmark.tags).filter(n => !this.selectedTags.includes(n))
      }
    },
    methods: {
      addTag(tag) {
        this.$emit('tagClicked', tag)
      },
      confirmDelete(id) {
        this.$emit('confirmDeleted', id)
      },
      deleteSelected(id) {
        this.$emit('deletedSelected', id)
      },
      editRecord(id) {
        this.$emit('editRecord', id)
      },
      reparse(id) {
        this.$emit('reparse', id)
      },
      wayback(bookmark) {
        this.$emit('wayback', bookmark)
      },
      showTags() {
        this.tagsVisible = true
      },
      openViaExtension(bookmark) {
        this.$emit('openUrlInFrame', bookmark)
      },
      setPlaceholder(e) {
        // e.target.classList.add('placeholder')
        e.target.src = "/images/defaults/globe-americas-solid.svg"
      },
      bookmarkClick(bookmark) {
        if(!this.bookmarkClickTimeout) {
          this.bookmarkClickTimeout = setTimeout(() => {
            this.bookmarkClickTimeout = null
            window.open(bookmark.url);
          }, 200);//tolerance in ms
        } else {
          clearTimeout(this.bookmarkClickTimeout)
          this.bookmarkClickTimeout = null
          this.$emit('openUrlInFrame', bookmark)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .offline {
    background: #f9f9f9;
    border-width: 1px;
    border-style: dashed;
    border-color: #e99898;
  }

  .bookmark-image {
    height: 140px;
    padding-top: 0;
  }
</style>
